/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_SubtitleInputs */

const cs_settings_prefs_subtitle = /** @type {(inputs: Settings_Prefs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak se vám zobrazují seznamy. Nemění firemní časové pásmo pro topování inzerátů.`)
};

const en_settings_prefs_subtitle = /** @type {(inputs: Settings_Prefs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How lists look for you. Does not change office timezone used for portal bumps.`)
};

/**
* | output |
* | --- |
* | "How lists look for you. Does not change office timezone used for portal bumps." |
*
* @param {Settings_Prefs_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_subtitle = /** @type {((inputs?: Settings_Prefs_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_subtitle(inputs)
	return cs_settings_prefs_subtitle(inputs)
});